/**
 * Development-only gate for the Simulation section.
 *
 * Simulation drives sandbox replays into the cloud the page is served from, so
 * it exists only on development deployments. The check is an allow-list: only
 * the development spellings below show it, and every other value, including an
 * empty or unknown one, hides it, so a new or misspelled production name can
 * never reveal it. The name is read inside the function rather than at module
 * scope because `config-overrides.js` rewrites `process.env.REACT_APP_ENVIRONMENT`
 * into an expression that prefers `window.RUNTIME_CONFIG`, which the deployed
 * `config.js` fills in at runtime.
 */

/** Environment names, lower-cased, on which the Simulation section is available. */
export const SIMULATION_ENVIRONMENTS: readonly string[] = ["dev", "development", "local"];

/**
 * Whether the running deployment is a development environment that may show
 * the Simulation section. Reads `process.env.REACT_APP_ENVIRONMENT` on every
 * call; `environment` overrides it (tests).
 */
export function isSimulationEnvironment(environment?: string): boolean {
  const value = environment ?? process.env.REACT_APP_ENVIRONMENT ?? "";
  return SIMULATION_ENVIRONMENTS.includes(value.trim().toLowerCase());
}
